import { takeEvery, put, call } from "redux-saga/effects";

import {
  getComplainsAPI,
  getComplainAPI,
  sendComplainReplyAPI,
} from "../../helpers/backend.helper";
import {
  GET_COMPLAINS,
  GET_COMPLAIN,
  SEND_COMPLAIN_REPLY,
} from "./actionTypes";
import {
  getComplainError,
  getComplainsError,
  getComplainsSuccess,
  getComplainSuccess,
  sendReplyToComplainError,
  sendReplyToComplainSuccess,
} from "./actions";

function* getComplains({ payload: { request } }) {
  try {
    const response = yield call(getComplainsAPI, request);
    if (response) {
      yield put(getComplainsSuccess(response?.data));
    }
  } catch (error) {
    yield put(getComplainsError(error));
  }
}

function* getComplain({ payload: { id } }) {
  try {
    const response = yield call(getComplainAPI, id);
    if (response) {
      yield put(getComplainSuccess(response?.data));
    }
  } catch (error) {
    yield put(getComplainError(error));
  }
}

function* sendReplyToComplain({ payload: data }) {
  try {
    const response = yield call(sendComplainReplyAPI, data);
    if (response) {
      yield put(sendReplyToComplainSuccess(response?.data));
    }
  } catch (error) {
    yield put(sendReplyToComplainError(error));
  }
}

function* complainSaga() {
  yield takeEvery(GET_COMPLAINS, getComplains);
  yield takeEvery(GET_COMPLAIN, getComplain);
  yield takeEvery(SEND_COMPLAIN_REPLY, sendReplyToComplain);
}

export default complainSaga;
